export function getPathRoot(path: string): string | undefined {
  return path.match(/^\/[^/?#]*/)?.[0] || '/';
}
